/**
 * Initialize mobile announcement slider by extracting text from desktop section
 */
(function() {
  function initMobileSlider() {
    const wrapper = document.getElementById('mobile-announcement-slider-wrapper');
    if (!wrapper) return;
    
    const sectionId = wrapper.getAttribute('data-section-id');
    const desktopSection = document.querySelector(`#shopify-section-${sectionId} .desktop-only-section`);
    
    if (!desktopSection) {
      console.warn('Desktop section not found for mobile slider');
      return;
    }
    
    // Extract text from all text blocks in desktop section
    const textBlocks = desktopSection.querySelectorAll('.text-block');
    const slides = [];
    
    textBlocks.forEach(block => {
      const text = block.textContent.trim();
      if (text) {
        slides.push(text);
      }
    });
    
    if (slides.length === 0) {
      console.warn('No text blocks found for mobile slider');
      return;
    }
    
    console.log('Mobile slider: Found', slides.length, 'slides:', slides);
    
    // Create slider HTML with inline styles to ensure visibility
    const sliderHTML = `
      <style>
        .mobile-slider {
          display: none;
          width: 100%;
          overflow: hidden;
          position: relative;
        }
        
        @media screen and (max-width: 749px) {
          .mobile-slider {
            display: block;
          }
        }
        
        .mobile-slider__track {
          display: flex;
          transition: transform 0.5s ease-in-out;
          will-change: transform;
        }
        
        .mobile-slider__slide {
          flex: 0 0 100%;
          min-width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px 16px;
        }
        
        .mobile-slider__text {
          text-align: center;
          margin: 0;
          font-size: 1rem;
          line-height: normal;
        }
        
        @media (prefers-reduced-motion: reduce) {
          .mobile-slider__track {
            transition: none;
          }
        }
      </style>
      <mobile-announcement-slider delay="3000" class="mobile-slider">
        <div class="mobile-slider__track">
          ${slides.map(slide => `
            <div class="mobile-slider__slide">
              <p class="mobile-slider__text">${slide}</p>
            </div>
          `).join('')}
        </div>
      </mobile-announcement-slider>
    `;
    
    wrapper.innerHTML = sliderHTML;
    console.log('Mobile slider: HTML inserted');
  }
  
  // Try multiple times to ensure DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileSlider);
  } else {
    initMobileSlider();
  }
  
  // Also try after a short delay as fallback
  setTimeout(initMobileSlider, 100);
})();

